<template>
  <div class="bg-body rounded p-5 pb-3 mb-5">
    <div class="d-flex align-items-center mb-3">
      <h4 class="align-items-start flex-column fw-bold text-gray-900 m-0 ms-2">
        {{ this.$route.meta.title || 'Страница' }}
        <span class="text-muted fw-normal fs-6">- Баннер</span>
      </h4>
      <slot name="create"></slot>
    </div>
    <div class="btn-custom-white d-flex ms-1 mb-2" role="group">
      <button
        type="button"
        @click="goToPage('Banner')"
        :class="this.$route.name === 'Banner' ? 'btn-success' : 'bg-secondary'"
        class="btn btn-sm me-2 mb-2"
      >
        Баннер
      </button>
      <button
        type="button"
        @click="goToPage('BannerCompany')"
        :class="this.$route.name === 'BannerCompany' ? 'btn-success' : 'bg-secondary'"
        class="btn btn-sm me-2 mb-2"
      >
        Компания
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BannerHeaderList',
  methods: {
    goToPage(page) {
      this.$router.push({ name: page });
    },
  },
}
</script>

<style scoped>

</style>
